// extracted by mini-css-extract-plugin
module.exports = {"mouse":"mouse_mouse__MQ_aL","imageWrapper":"mouse_imageWrapper__zK5XV"};